<script>
export default {
  props: {
    title: String,
    icon: {
      type: String,
      default: 'arrow',
    },
    orderTheme: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: this.expanded,
      id: Math.floor(Math.random() * 10000),
    }
  },
  methods: {
    handleHeaderClick() {
      this.isActive = !this.isActive
    },
  },
}
</script>

<template>
  <div>
    <div role="tab" :aria-expanded="isActive" :aria-controls="`el-collapse-content-${id}`" :aria-describedby="`el-collapse-content-${id}`" :class="[$style.wrapper, { [$style.trans]: orderTheme }]">
      <div :id="`el-collapse-head-${id}`" role="button" :class="$style.header" @click="handleHeaderClick">
        <BaseIcon v-if="icon !== 'arrow'" :class="$style['header-icon']" :name="isActive ? 'minus' : 'plus'" />
        <slot name="title">{{ title }}</slot>
        <BaseIcon v-if="icon === 'arrow'" :class="$style['header-icon-right']" :icon-style="'fal'" :name="isActive ? 'chevron-down' : 'chevron-right'" />
      </div>
      <div v-show="isActive" :id="`el-collapse-content-${id}`" role="tabpanel" :aria-hidden="!isActive" :aria-labelledby="`el-collapse-head-${id}`" :class="$style.content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.wrapper {
  background: white;
  &.trans {
    background: transparent;
    border-bottom: 1px solid #c6c6ba;
    > .header {
      padding: 31px 0;
      font-size: 16px;
      letter-spacing: 1.6px;
      font-weight: inherit;
      cursor: pointer;

      &-icon {
        margin-right: 10px;
      }
    }
    > .content {
      padding: 0;
      padding-bottom: 40px;
    }
  }
}
.header {
  padding: 15px;
  font-size: ms(1);
  font-weight: bold;
  cursor: pointer;

  &-icon {
    margin-right: 10px;
  }
}
.header-icon-right {
  float: right;
  margin: 0;
}
.content {
  padding: 5px 15px;
}
</style>
